export const MALE_QUESTIONS = {
    safety: {
        id: 'safety',
        number: 1,
        text: 'First, let\'s confirm, do you currently have any of the following conditions?',
        hint: 'For your health and safety, we need to know these first',
        type: 'checkbox',
        options: [
            { value: 'partner_pregnant', label: '🤰 Partner is pregnant or planning to conceive' },
            { value: 'heart_disease', label: '❤️ Have heart disease or severe hypertension' },
            { value: 'medication', label: '💊 Taking related medications (e.g., PDE5 inhibitors)' },
            { value: 'prostate', label: '🩺 Have prostate issues' },
            { value: 'none', label: '✓ None of the above, continue', exclusive: true }
        ]
    },

    demographics: {
        id: 'demographics',
        number: 2,
        text: 'Tell us some basic information',
        type: 'multi-part',
        parts: [
            {
                id: 'age',
                label: 'Age Group',
                type: 'radio',
                options: [
                    { value: '25-35', label: '25-35 years' },
                    { value: '36-45', label: '36-45 years' },
                    { value: '46-55', label: '46-55 years' },
                    { value: '56-65', label: '56-65 years' },
                    { value: 'other', label: 'Other age group' }
                ]
            },
            {
                id: 'weight',
                label: 'Weight',
                type: 'radio',
                options: [
                    { value: '<70', label: '< 154 lbs (< 70 kg)' },
                    { value: '70-85', label: '154-187 lbs (70-85 kg)' },
                    { value: '85-100', label: '187-220 lbs (85-100 kg)' },
                    { value: '>100', label: '> 220 lbs (> 100 kg)' }
                ]
            }
        ]
    },

    mainConcern: {
        id: 'mainConcern',
        number: 3,
        text: 'What do you mainly want to improve?',
        type: 'radio',
        options: [
            { value: 'energy', label: '💪 Decreased physical strength/energy, always tired' },
            { value: 'sleep', label: '😴 Poor sleep quality, affecting state' },
            { value: 'stress', label: '🧠 High stress, mental tension' },
            { value: 'overall', label: '🌱 Overall conditioning, improve state' }
        ]
    },

    // 分支A：体力精力下降
    energyIssues: {
        id: 'energyIssues',
        number: 4,
        text: 'What are your main energy issues?',
        hint: 'Select 1-2 that bother you the most',
        type: 'checkbox',
        maxSelect: 2,
        condition: (answers) => answers.mainConcern === 'energy',
        options: [
            { value: 'fatigue', label: '💤 Easily fatigued, no energy to do things' },
            { value: 'lower_back', label: '🦴 Weak waist and knees, uncomfortable lower back' },
            { value: 'slow_recovery', label: '🏃 Slow recovery after exercise' },
            { value: 'morning_tired', label: '🌅 Poor state in the morning' }
        ]
    },

    energyDuration: {
        id: 'energyDuration',
        number: 5,
        text: 'How long has this lasted?',
        type: 'radio',
        condition: (answers) => answers.mainConcern === 'energy',
        options: [
            { value: '1-3months', label: 'Last 1-3 months' },
            { value: '3-6months', label: '3-6 months' },
            { value: '>6months', label: 'Over half a year' }
        ]
    },

    lowerBackDetails: {
        id: 'lowerBackDetails',
        number: 6,
        text: 'Discomfort in waist/knees?',
        hint: 'Select all that apply',
        type: 'checkbox',
        condition: (answers) => answers.energyIssues?.includes('lower_back'),
        options: [
            { value: 'back_pain', label: 'Lower back often sore/painful' },
            { value: 'knee_weak', label: 'Weak knees' },
            { value: 'worse_sitting', label: 'Worse after sitting or standing for long' },
            { value: 'weather', label: 'Worse when weather changes' }
        ]
    },

    // 分支B：睡眠质量差
    sleepIssues: {
        id: 'sleepIssues',
        number: 4,
        text: 'What is your sleep issue?',
        hint: 'Select all that apply',
        type: 'checkbox',
        condition: (answers) => answers.mainConcern === 'sleep',
        options: [
            { value: 'difficulty_falling', label: '😴 Difficulty falling asleep' },
            { value: 'light_sleep', label: '😮‍💨 Light sleep, easily wake up' },
            { value: 'sleep_tired', label: '💤 Sleep a lot but still tired' },
            { value: 'dreams', label: '😰 Many dreams, poor sleep quality' }
        ]
    },

    sleepDuration: {
        id: 'sleepDuration',
        number: 5,
        text: 'How long has the sleep issue lasted?',
        type: 'radio',
        condition: (answers) => answers.mainConcern === 'sleep',
        options: [
            { value: '1-3months', label: 'Last 1-3 months' },
            { value: '3-6months', label: '3-6 months' },
            { value: '>6months', label: 'Over half a year' }
        ]
    },

    sleepImpact: {
        id: 'sleepImpact',
        number: 6,
        text: 'Impact during the day after poor sleep?',
        hint: 'Select all that apply',
        type: 'checkbox',
        condition: (answers) => answers.mainConcern === 'sleep',
        options: [
            { value: 'poor_focus', label: 'Poor spirit, lack of focus' },
            { value: 'fatigue', label: 'Easily fatigued' },
            { value: 'irritable', label: 'Irritable mood' },
            { value: 'low_energy', label: 'Decreased physical strength' }
        ]
    },

    // 分支C：压力大
    stressSources: {
        id: 'stressSources',
        number: 4,
        text: 'Stress mainly comes from?',
        hint: 'Select all that apply',
        type: 'checkbox',
        condition: (answers) => answers.mainConcern === 'stress',
        options: [
            { value: 'work', label: '💼 Work stress' },
            { value: 'family', label: '👨‍👩‍👧‍👦 Family life stress' },
            { value: 'anxiety', label: '😰 Often anxious/nervous' },
            { value: 'sleep_stress', label: '😴 Stress causes poor sleep' }
        ]
    },

    stressDuration: {
        id: 'stressDuration',
        number: 5,
        text: 'How long has the stress state lasted?',
        type: 'radio',
        condition: (answers) => answers.mainConcern === 'stress',
        options: [
            { value: '1-3months', label: 'Last 1-3 months' },
            { value: '3-6months', label: '3-6 months' },
            { value: '>6months', label: 'Over half a year' }
        ]
    },

    stressImpact: {
        id: 'stressImpact',
        number: 6,
        text: 'Impact of stress on you?',
        hint: 'Select all that apply',
        type: 'checkbox',
        condition: (answers) => answers.mainConcern === 'stress',
        options: [
            { value: 'tense', label: 'Mentally tense, hard to relax' },
            { value: 'fatigue', label: 'Easily fatigued' },
            { value: 'sleep', label: 'Affects sleep' },
            { value: 'appetite', label: 'Appetite changes' }
        ]
    },

    // 分支D：整体调理
    overallGoals: {
        id: 'overallGoals',
        number: 4,
        text: 'What do you mainly want to prevent or improve?',
        hint: 'Select all that apply',
        type: 'checkbox',
        condition: (answers) => answers.mainConcern === 'overall',
        options: [
            { value: 'prevent_decline', label: '💪 Prevent decline in physical strength' },
            { value: 'boost_immunity', label: '🛡️ Boost overall immunity' },
            { value: 'mental', label: '🧘 Improve mental state' },
            { value: 'exercise', label: '🏃 Support exercise/fitness' }
        ]
    },

    overallStatus: {
        id: 'overallStatus',
        number: 5,
        text: 'Your current status?',
        type: 'radio',
        condition: (answers) => answers.mainConcern === 'overall',
        options: [
            { value: 'good', label: '😊 Status is okay, want prevention' },
            { value: 'slight_decline', label: '😐 Feel slight decline, want conditioning' },
            { value: 'obvious_decline', label: '😔 Obviously feel not as good as before' }
        ]
    },

    // 通用问题
    constitution: {
        id: 'constitution',
        number: 7,
        text: 'Constitution characteristics?',
        hint: 'Select all that apply',
        type: 'checkbox',
        options: [
            { value: 'cold_limbs', label: '🧊 Cold hands and feet, fear of cold' },
            { value: 'sweating', label: '😓 Easily sweat (day or night)' },
            { value: 'dry_mouth', label: '💧 Dry mouth, always want to drink water' },
            { value: 'heat', label: '🔥 Easily inflamed' },
            { value: 'none', label: 'None of the above', exclusive: true }
        ]
    },

    otherSymptoms: {
        id: 'otherSymptoms',
        number: 8,
        text: 'Do you also have these conditions?',
        hint: 'Select all that apply',
        type: 'checkbox',
        options: [
            { value: 'lower_back_pain', label: '🦴 Weak waist and knees' },
            { value: 'dizziness', label: '😵 Dizziness, tinnitus' },
            { value: 'frequent_urination', label: '🚽 Frequent urination (especially at night)' },
            { value: 'hair_loss', label: '💇 Obvious hair loss' },
            { value: 'none', label: 'None of the above', exclusive: true }
        ]
    },

    lifestyle: {
        id: 'lifestyle',
        number: 9,
        text: 'Lifestyle habits?',
        hint: 'Select all that apply',
        type: 'checkbox',
        options: [
            { value: 'alcohol', label: '🍺 Drink alcohol often' },
            { value: 'smoking', label: '🚬 Smoke' },
            { value: 'late_sleep', label: '😴 Stay up late often (sleep after 12)' },
            { value: 'exercise', label: '🏃 Regular exercise (3+ times a week)' },
            { value: 'sedentary', label: '💻 Sedentary (sit for >8 hours a day)' },
            { value: 'healthy', label: 'Relatively healthy' }
        ]
    },

    familyPlanning: {
        id: 'familyPlanning',
        number: 10,
        text: 'Any plans for conceiving?',
        type: 'radio',
        options: [
            { value: 'planning_now', label: 'Yes, currently trying' },
            { value: 'planning_soon', label: 'Yes, but not urgent (within a year)' },
            { value: 'no_plan', label: 'No plans in this regard' }
        ]
    }
};